import React from 'react';

export default function Footer(){
  return (
    <footer className="footer">
      <div>GamerFrog Reviews • {new Date().getFullYear()}</div>
      {/* <div style={{color:'var(--muted)', marginTop:6}}>Demo data stored in localStorage (key: gr_reviews_v1)</div> */}
    </footer>
  );
}
